export default __webpack_public_path__ + "static/media/07-INT-(7-5).ac19824e.jpg";